import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { IDatePickerConfig } from 'ng2-date-picker';
import { getAvailableTransitAllowance, getAvailableUnpaidBreak } from 'src/modules/company-dashboard/constants/job-constants';
import { BroadcastJobsUtilService } from 'src/modules/company-dashboard/services/broadcast-job-utils.service';
import { RecurrentShiftService } from 'src/modules/talent-dashboard/services/recurrentShift.service';
import { IShiftTime } from '../../interfaces/shift-time.interface';
import { FormCheckboxComponent } from '../form-checkbox/form-checkbox.component';
import { CompanyTypeEnum } from 'src/modules/onboarding-company/enums/company-type.enum';
import { UnpaidBreak } from '../../enums/unpaid-break.enum';


@Component({
  selector: 'app-edit-recurring-shift-list-item',
  templateUrl: './edit-recurring-shift-list-item.component.html',
  styleUrls: ['./edit-recurring-shift-list-item.component.scss'],
})

export class EditRecurringShiftListItemComponent implements OnInit {
  @ViewChild('checkBox', { static: false }) checkBoxRef: FormCheckboxComponent;
  @Input() config: Array<string>;
  @Input() control: any;
  @Input() data;
  @Input() showEditIcon? : boolean = true
  @Input() confirmationView: Boolean = false
  @Input() companyType?: string;
  @Input() settings?: any;
  @Input() currentView?: string;
  availableTransitAllowance: Array<{label: string, value: string}>;
  availableUnpaidBreak: Array<{label: string, value: string}>;
  startTimeValues : Array<IShiftTime>;
  endTimeValues : Array<IShiftTime>;
  @Output() onToggleCheckBox = new EventEmitter<boolean>();
  isDelete: boolean = false;
  checkBoxOptions = [{
    label: ""
  }]

  dateConfig: IDatePickerConfig = {
    allowMultiSelect: false,
    format: 'DD MMM,YY',
    closeOnSelect: true,
    showGoToCurrent: true,
    disableKeypress: true,
    unSelectOnClick: false,
    hideOnOutsideClick: true
  };

  constructor(private cdr: ChangeDetectorRef, private broadcastJobsUtilService: BroadcastJobsUtilService, private recurrentShiftService: RecurrentShiftService) { }

  ngOnInit() {

    if (this.confirmationView) {
      return
    }
    this.availableTransitAllowance = getAvailableTransitAllowance()

    this.availableUnpaidBreak = getAvailableUnpaidBreak()

    this.getStartandEndTimeForDay(
      !this.showEditIcon ?  moment(this.control.get("date").value, 'MMM DD, YYYY ddd').format() : moment(moment().format('MM/DD/YYYY'), 'MM/DD/YYYY').format(),
      !this.showEditIcon ?  moment(this.control.get("date").value, 'MMM DD, YYYY ddd').format() : moment(moment().format('MM/DD/YYYY'), 'MM/DD/YYYY').format(),
    );

    const startIndex = this.recurrentShiftService.fetchTimingIndex(this.startTimeValues, this.control, 'startTime')
    const endIndex = this.recurrentShiftService.fetchTimingIndex(this.endTimeValues, this.control, 'endTime')
    const unpaidBreakIndex = this.recurrentShiftService.fetchUnpaidBreakIndex(this.availableUnpaidBreak, this.control, 'unpaidBreak');
    const travelAllowanceIndex = this.recurrentShiftService.fetchTravelAllowanceIndex(this.availableTransitAllowance, this.control, 'transitAllowance');

    if (startIndex > -1) {
      this.control.get('startTime').setValue(this.startTimeValues[startIndex]);
    }

    if (endIndex > -1) {
      this.control.get('endTime').setValue(this.endTimeValues[endIndex]);
    }

    if (unpaidBreakIndex > -1) {
      this.control.get('unpaidBreak').setValue(this.availableUnpaidBreak[unpaidBreakIndex]);
    }

    if (travelAllowanceIndex > -1) {
      this.control.get('transitAllowance').setValue(this.availableTransitAllowance[travelAllowanceIndex]);
    }

  }

  getStartandEndTimeForDay(startVal: string, endVal: string) {
    this.startTimeValues = this.broadcastJobsUtilService.generatedStepArray(startVal);
    this.endTimeValues = this.broadcastJobsUtilService.generatedStepArray(endVal);
  }

  getAvailableOptions(key: string) {
    if (key == "Start Time") {
      return this.startTimeValues
    } else if (key == "End Time") {
      return this.endTimeValues
    } else if (key == "Transit Allowance") {
      return this.availableTransitAllowance
    } else if (key == "Unpaid Break") {
      return this.availableUnpaidBreak
    }
  }

  getFormControl(key: string) {
    if (key == "Date") {
      return 'date'
    } else if (key == "Start Time") {
      return 'startTime'
    } else if (key == "End Time") {
      return 'endTime'
    } else if (key == "Transit Allowance") {
      return 'transitAllowance'
    } else if (key == "Unpaid Break") {
      return 'unpaidBreak'
    } else if (key == "selected") {
      return 'selected'
    }
  }

  getFormControlValue(key: string) {
    if (!this.control.get(this.getFormControl(key))) {
      return false;
    }

    if (typeof this.control.get(this.getFormControl(key)).value == "object") {
      return this.control.get(this.getFormControl(key)).value.formatted || this.control.get(this.getFormControl(key)).value.label
    }
    return this.control.get(this.getFormControl(key)).value;
  }

  getLabelKey(key: string) {
    if (key == "Start Time" || key == "End Time") {
      return 'formatted'
    } else {
      return 'label'
    }
  }

  onValueChange(event: any, key: string) {
    // update break time when start time or end time is changed
    if (!this.showEditIcon && ( key === 'Start Time' || key === 'End Time')) {
      
      if(key === 'Start Time') {
        this.populateEndTimeList();
      }

      if(!this.control.get('unpaidBreak')){
        return;
      }

      const unpaidBreak = this.setUnpaidBreakDropdown(this.control.get('startTime').value, this.control.get('endTime').value);
      this.control.get('unpaidBreak').setValue({
        label: unpaidBreak,
        value: unpaidBreak,
      });
      const unpaidBreakIndex = this.recurrentShiftService.fetchUnpaidBreakIndex(this.availableUnpaidBreak,this.control,'unpaidBreak');
      if(unpaidBreakIndex > -1) {
        this.control.get('unpaidBreak').setValue(this.availableUnpaidBreak[unpaidBreakIndex]);
      }
    }
  } 

  populateEndTimeList() {

    const startTimeObj = this.control.get('startTime').value;
    const startTimeMoment = moment.unix(startTimeObj.value); // Assuming `singleDayStartTime.value` is a Unix timestamp
    const minEndTime = startTimeMoment.clone().add(15, 'minutes').format(); // 15 minutes ahead

    // Generate possible end times and filter invalid ones
    this.endTimeValues = this.broadcastJobsUtilService
    .generatedStepArray(minEndTime)
    .filter((time) => moment.unix(Number(time.value)).isAfter(startTimeMoment) || time.formatted === 'Next Day'); // Filter values after start time

    // Set the first valid end time or reset if none
    const shiftEndTime = this.endTimeValues[0];
    this.control.get('endTime').setValue(shiftEndTime);
  }


  setUnpaidBreakDropdown(startTime, endTime) {
    if(this.companyType == CompanyTypeEnum.HEALTHCARE || this.companyType == CompanyTypeEnum.RETIREMENT_HOME){
      const diffInMilliseconds = moment(endTime.value * 1000).diff(startTime.value * 1000);
      const diffInMinutes = Math.round(moment.duration(diffInMilliseconds).asMinutes());
  
      let unpaidBreak: UnpaidBreak;
      if (this.settings) {
        for (const unpaidBreakConfig of this.settings[0].unpaidBreakConfigs) {
          if (diffInMinutes >= unpaidBreakConfig.shiftTimeInMinutes) {
            unpaidBreak = unpaidBreakConfig.breakTime;
          }
        }
      }
      return unpaidBreak;
    } else{
      return UnpaidBreak.EMPTY;
    }
   
  };
  toggleCheckBox() {
    let value = this.getFormControlValue("selected")
    this.onToggleCheckBox.emit(!value);
    this.control.get("selected").setValue(!value)
  }
}

